import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IMG_URL } from "../../Services/Api";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import add from "../../Assets/Image/admin/add.png";
import Select from "react-select";
import {
  deleteCampaignApi,
  getCampainList,
  getCategoryList,
} from "../../Services/ApiServices";
import noImage from "../../Assets/Image/admin/user.png";
import { CircleX, Edit, Eye, PenLine, Trash, Trash2 } from "lucide-react";
import Dialog from "../../Base-Component/Dialog/Dialog";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";

export default function CampaignPage() {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);
  const [categoryData, setCategoryData] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [totalPage, setTotalPage] = useState("1");
  const [campaignData, setCampaignData] = useState([]);
  const [campaignId, setCampaignId] = useState(null);
  const [listLoading, setListLoading] = useState(false);
  const [index, setIsIndex] = useState(null);

  const handleCategoryList = () => {
    setListLoading(true);
    getCategoryList()
      .then((res) => {
        const data = res.data.data;
        setCategoryData(data);
        const option = data?.map((item) => ({
          label: (
            <div className="flex items-center p-1 uppercase">
              <img
                src={
                  item.category_image ? IMG_URL + item.category_image : noImage
                }
                className="w-14 h-14 rounded-md object-cover mr-2"
              />
              {item.category_name || ""}
            </div>
          ),
          value: item.id,
          id: item.category_name,
        }));

        if (option?.length > 0) {
          setSelectedOption(option[0]);
        }
        setListLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setListLoading(false);
      });
  };

  useEffect(() => {
    handleCategoryList();
  }, []);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "50px",
      height: "50px",
      border: "none",
      outline: "0px",
      boxShadow: "none",
      "&:hover": {
        border: "none",
      },
      "&:focus": {
        border: "none",
        boxShadow: "none",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "50px",
      padding: "0 8px",
      border: "0px",
      outline: "0px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "50px",
      border: "0px",
      outline: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
      backgroundColor: state.isSelected
        ? "#e29c2995"
        : state.isFocused
        ? "#e29c2940"
        : "white",
      ":active": {
        backgroundColor: "#e29c2910",
        color: "white",
      },
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      return {
        ...provided,
        opacity,
        transition,
        display: "flex",
        alignItems: "center",
      };
    },
  };

  const openDialog = (campaign) => {
    setSelectedCampaign(campaign);
    setModalOpen(true);
  };

  const handleGetCampaign = () => {
    setListLoading(true);
    let obj = {
      page: pageNo,
      category_id: selectedOption?.value,
    };

    getCampainList(obj)
      .then((res) => {
        const data = res.data.data;
        setCampaignData(data);
        setTotalPage(res.data.totalPages);
        setListLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setListLoading(false);
      });
  };

  useEffect(() => {
    if (selectedOption) {
      handleGetCampaign();
    }
  }, [selectedOption, pageNo]);

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const handleDeleteView = (id, index) => {
    setIsDelete(true);
    setCampaignId(id);
    setIsIndex(index);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      id: campaignId,
    };

    deleteCampaignApi(obj)
      .then((res) => {
        toast.success(res.data.message);
        setIsDelete(false);
        const data = [...campaignData];
        data.splice(index, 1);
        setCampaignData(data);
        setIsLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setIsLoading(false);
      });
  };

  const HtmlContent = ({ htmlString }) => {
    const sanitizedHtml = DOMPurify.sanitize(htmlString);
    const style = `
                ol {
                  margin: 0;
                  padding: 0;
                  list-style-type: decimal; /* Numbering */
                  padding-left: 20px; /* Adjust left padding as needed */
                }
                ul {
                  margin: 0;
                  padding: 0;
                  list-style-type: disc; /* Bullets */
                  padding-left: 20px; /* Adjust left padding as needed */
                }
                li {
                  margin: 0;
                  padding: 0;
                  line-height: 1.5;
                }
                a {
                  color: blue;
                }
              `;

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `<style>${style}</style>${sanitizedHtml}`,
        }}
      />
    );
  };

  HtmlContent.propTypes = {
    htmlString: PropTypes.string.isRequired,
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex sm:flex-nowrap flex-wrap justify-end mb-7">
        <div className="flex sm:flex-nowrap flex-wrap-reverse items-center justify-end sm:w-auto w-full">
          <div>
            <button
              onClick={() => navigate("/add-campaign")}
              className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
            >
              <img src={add} className="w-6 mr-2" alt="" />
              Add Campaign
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 mb-5">
        <div className="lg:col-span-6 col-span-12">
          <Select
            value={selectedOption}
            onChange={(option) => {
              setSelectedOption(option);
              // setPageNo(1);
            }}
            options={categoryData?.map((item) => ({
              label: (
                <div className="flex items-center p-1 uppercase">
                  <img
                    src={
                      item.category_image
                        ? IMG_URL + item.category_image
                        : noImage
                    }
                    className="w-14 h-14 rounded-md object-cover mr-2"
                  />
                  {item.category_name || ""}
                </div>
              ),
              value: item.id,
              id: item.category_name,
            }))}
            placeholder="Select Category"
            className="bg-white py-2 outline-0 rounded-lg"
            styles={customStyles}
          />
        </div>
      </div>

      {listLoading ? (
        <div className="flex justify-center items-center col-span-12 h-[70vh]">
          <Bars
            height="35"
            width="35"
            color="#e29c29"
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      ) : (
        <>
          {campaignData?.length === 0 ? (
            <div className="col-span-12 h-[50vh] justify-center flex items-center">
              <img src={nodata} className="w-28" alt="No data" />
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-6">
                {campaignData?.map((campaign, index) => (
                  <div
                    key={campaign.id}
                    className="bg-white shadow-lg rounded-lg overflow-hidden border p-4"
                  >
                    <img
                      src={IMG_URL + campaign.image}
                      alt={campaign.title}
                      className="w-full sm:h-72 h-52 object-cover rounded-lg"
                    />

                    <div className="mt-4">
                      <h2 className="text-base font-medium text-gray-900">
                        {campaign.title}
                      </h2>
                      <p className="text-gray-600 mt-1 text-sm line-clamp-1">
                        {" "}
                        <HtmlContent htmlString={campaign?.description || ""} />
                      </p>

                      <div className="mt-3 flex gap-2 items-center">
                        <p className="text-gray-700 text-sm font-semibold">
                          Start Date:
                        </p>
                        <div className="flex items-center gap-2 text-gray-500 text-sm">
                          <span>{campaign.start_date}</span>
                        </div>
                      </div>

                      <div className="mt-2 flex gap-2 items-center">
                        <p className="text-gray-700 text-sm font-semibold">
                          End Date:
                        </p>
                        <div className="flex items-center gap-2 text-gray-500 text-sm">
                          <span>{campaign.end_date}</span>
                        </div>
                      </div>
                      <div className="border-t my-4"></div>
                      <div className="flex text-sm justify-between items-center">
                        <p
                          onClick={() => openDialog(campaign)}
                          className="flex items-center font-medium text-[#3b82f6]"
                        >
                          <Eye color="#3b82f6" size={17} className="mr-1" />{" "}
                          View
                        </p>
                        <p
                          onClick={() => handleDeleteView(campaign.id, index)}
                          className="flex items-center font-medium text-[#e43232]"
                        >
                          <Trash2 color="#e43232" size={17} className="mr-1" />{" "}
                          Delete
                        </p>
                        <p
                          onClick={() =>
                            navigate("/edit-campaign/" + campaign.id)
                          }
                          className="flex items-center font-medium text-[#000cff]"
                        >
                          <PenLine color="#000cff" size={17} className="mr-1" />{" "}
                          Edit
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="col-span-12 flex flex-wrap items-center sm:justify-end mt-8 justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                <div className="flex items-center cursor-pointer">
                  <p
                    onClick={() => handlePageChange(pageNo - 1)}
                    disabled={pageNo === 1}
                  >
                    Previous
                  </p>
                  <div className="flex items-center mx-6">
                    {renderPaginationButtonss()}
                  </div>
                  <p
                    onClick={() => handlePageChange(pageNo + 1)}
                    disabled={pageNo === totalPage}
                  >
                    Next
                  </p>
                </div>
              </div>
            </>
          )}
        </>
      )}

      <Dialog size="xl" open={isModalOpen} onClose={() => setModalOpen(false)}>
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white p-4 bg-white">
            <div className="flex justify-between border-b pb-4 items-center">
              <h4 className="text-lg font-medium">Campaign Details</h4>
              <CircleX
                color="gray"
                size={28}
                onClick={() => setModalOpen(false)}
                className="cursor-pointer"
              />
            </div>
            {selectedCampaign && (
              <>
                <img
                  src={IMG_URL + selectedCampaign.image}
                  alt={selectedCampaign.title}
                  className="w-full mt-4 h-72 object-cover rounded-lg"
                />
                <h2 className="text-lg font-medium mt-4">
                  {selectedCampaign.title}
                </h2>
                <p className="text-gray-600 mt-1">
                  {" "}
                  <HtmlContent
                    htmlString={selectedCampaign?.description || ""}
                  />
                </p>

                <div className="mt-2 flex gap-2 items-center">
                  <p className="text-gray-700 font-semibold">Category name:</p>
                  <div className="flex items-center gap-2 text-gray-500">
                    <span>{selectedCampaign?.category?.category_name}</span>
                  </div>
                </div>

                <div className="mt-2 flex gap-2 items-center">
                  <p className="text-gray-700 font-semibold">UserRole:</p>
                  <div className="flex items-center gap-2 text-gray-500">
                    <span>{selectedCampaign?.userRole?.role_name}</span>
                  </div>
                </div>

                <div className="mt-2 flex gap-2 items-center">
                  <p className="text-gray-700 font-semibold">Start Date:</p>
                  <div className="flex items-center gap-2 text-gray-500">
                    <span>{selectedCampaign?.start_date}</span>
                  </div>
                </div>

                <div className="mt-2 flex gap-2 items-center">
                  <p className="text-gray-700 font-semibold">End Date:</p>
                  <div className="flex items-center gap-2 text-gray-500">
                    <span>{selectedCampaign?.end_date}</span>
                  </div>
                </div>
              </>
            )}
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete Campaign?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this Campaign?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}
